import React from 'react';
import type { ITablaEquiposVistaProps } from '../interfaces';
import Tabla from '../../../globales/componentes/tabla/tabla';
import { ActionIcon, Box, Button, Group, Tooltip, Text } from '@mantine/core';
import { IconCloudUpload, IconEye, IconFileDownload, IconFilter, IconFilterFilled, IconPlus, IconRefresh } from '@tabler/icons-react';
import FormularioEquipoVista from './formularioEquiposVista';
import FiltroEquiposVista from './filtroEquiposVista';

const TablaEquiposVista: React.FunctionComponent<ITablaEquiposVistaProps> = ({
  tabla,
  equipoSeleccionado: equipo,
  manejarCambioValorEquipo,
  agregarEditarEquipo: crearEditarEquipo,
  entidadesEquipo,
  agregarError,
  errores,
  filtro,
  consultarEquipos,
  manejarCambioFiltroEquipo,
  limpiarFiltros,
  habilitarFiltros,
  manejarHabilitarFiltros,
  habilitarFormulario,
  manejarHabilitarFormulario,
  descargarPlantilla,
  cargaMasivaEquipos,
  pantallaCompleta
}) => {

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: pantallaCompleta ? '75vh' : '55vh', minHeight: 0 }}>
      <Box pos="sticky" pb={2} style={{ zIndex: 20 }} top={0} bg="white">
        <Group justify="space-between" pt="sm" >
          <Button
            color="primary"
            onClick={() => manejarHabilitarFormulario(!habilitarFormulario)}
            variant="light"
            size='compact-sm'
            leftSection={habilitarFormulario ? <IconEye opacity={100} size={15} /> : <IconPlus opacity={100} size={15} />}
            radius="lg"
          >
            <Text fw={500} fz={11}>{habilitarFormulario ? "Ver Equipos" : "Agregar Equipo"}</Text>
          </Button>
          <Group>
            <Tooltip zIndex={100000} label="Descargar Plantilla" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={descargarPlantilla}
              >
                <IconFileDownload size={20} />
              </ActionIcon>
            </Tooltip>
            <Tooltip zIndex={100000} label="Carga Masiva" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={cargaMasivaEquipos}
              >
                <IconCloudUpload size={20} />
              </ActionIcon>
            </Tooltip>

            {!habilitarFormulario && (
              <Group gap={4}>
                <Tooltip
                  label="Refrescar"
                  withinPortal
                  openDelay={100}
                  zIndex={9999}
                  style={{ fontSize: '10px', padding: '3px 5px' }}
                >
                  <ActionIcon
                    variant="subtle"
                    color="primary"
                    radius="xl"
                    onClick={() => consultarEquipos()}
                  >
                    <IconRefresh size={16} />
                  </ActionIcon>
                </Tooltip>
                <Tooltip
                  label="Filtrar"
                  withinPortal
                  openDelay={100}
                  zIndex={9999}
                  style={{ fontSize: '10px', padding: '3px 5px' }}
                >
                  <ActionIcon
                    variant="subtle"
                    color="primary"
                    radius="xl"
                    onClick={() => manejarHabilitarFiltros(!habilitarFiltros)}
                  >
                    {habilitarFiltros ? <IconFilterFilled size={16} /> : <IconFilter size={16} />}
                  </ActionIcon>
                </Tooltip>
              </Group>
            )}
          </Group>
        </Group>

      </Box>
      {habilitarFormulario ? (
        <Box style={{ flex: 1, overflowY: 'auto' }}>
          <FormularioEquipoVista
            agregarEditarEquipo={crearEditarEquipo}
            entidadesEquipo={entidadesEquipo}
            equipoSeleccionado={equipo}
            manejarCambioValorEquipo={manejarCambioValorEquipo}
            agregarError={agregarError}
            errores={errores}
          />
        </Box>
      ) : (
        // <div style={{
        //   flex: 1,           // 👈 Obliga a la tabla a expandirse
        //   display: 'flex',
        //   flexDirection: 'column',
        //   minHeight: 0       // 👈 Crucial para que el scroll interno funcione
        // }}>
        <>
          {habilitarFiltros && (
            <Box style={{ flexShrink: 0 }}>
              <FiltroEquiposVista
                consultarEquipos={consultarEquipos}
                filtro={filtro}
                manejarCambioFiltroEquipo={manejarCambioFiltroEquipo}
                entidadesEquipo={entidadesEquipo}
                limpiarFiltros={limpiarFiltros}
              />
            </Box>
          )}
          <div style={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden' // Protege el desborde
          }}>
            <Tabla
              tabla={tabla}
            />
          </div>
        </>
      )}

    </div>
  );
};

export default TablaEquiposVista;
